import {
  AWSKeyManagementAPI,
  CreateKeyResponse,
  CreateKeyUserInput,
  DeleteKeyResponse,
  KeyResponseItem,
  ListKeyResponse,
} from '../apis/keyManagementApi';

export class MockAWSKeyManagementClient implements AWSKeyManagementAPI {
  private keys: KeyResponseItem[];

  constructor() {
    this.keys = [
      {
        purpose: 'testing the system out',
        central_creator_email: 'abiju@chanzuckerberg.com',
        iam_user_name: 'test-key3',
        czi_users_emails: [
          'abiju@chanzuckerberg.com',
        ],
        current_status: 'ACTIVE',
        creation: '2024-02-07T02:14:23.159199',
        iam_statements: [
          {
            Resource: '*',
            Condition: {
              DateGreaterThan: {
                'aws:CurrentTime': '2024-02-07T02:14:23.159199',
              },
              DateLessThan: {
                'aws:CurrentTime': '2024-02-10T01:16:35+0000',
              },
            },
            Effect: 'Allow',
            Action: [
              's3:Get*',
              's3:List*',
              's3:Describe*',
              's3-object-lambda:Get*',
              's3-object-lambda:List*',
            ],
          },
        ],
        expiration: '2024-02-10T01:16:35+0000',
        id: '401986845158-test-key3',
        account_id: '401986845158',
        end_users_emails: [
          'abiju@chanzuckerberg.com',
        ],
      },
      {
        purpose: 'testing the system out',
        central_creator_email: 'abiju@chanzuckerberg.com',
        iam_user_name: 'abiju-test-key1',
        czi_users_emails: [
          'abiju@chanzuckerberg.com',
        ],
        current_status: 'ACTIVE',
        creation: '2024-02-06T18:49:02.885140',
        iam_statements: [
          {
            Resource: '*',
            Condition: {
              DateGreaterThan: {
                'aws:CurrentTime': '2024-02-06T18:49:02.885140',
              },
              DateLessThan: {
                'aws:CurrentTime': '2024-02-10T01:16:35+0000',
              },
            },
            Effect: 'Allow',
            Action: [
              's3:Get*',
              's3:List*',
              's3:Describe*',
              's3-object-lambda:Get*',
              's3-object-lambda:List*',
            ],
          },
        ],
        expiration: '2024-02-10T01:16:35+0000',
        id: '401986845158-abiju-test-key1',
        account_id: '401986845158',
        end_users_emails: [
          'abiju@chanzuckerberg.com',
        ],
      },
      {
        purpose: 'testing the system out',
        central_creator_email: 'abiju@chanzuckerberg.com',
        iam_user_name: 'test-key4',
        czi_users_emails: [
          'abiju@chanzuckerberg.com',
        ],
        current_status: 'ACTIVE',
        creation: '2024-02-07T02:17:26.975344',
        iam_statements: [
          {
            Resource: '*',
            Condition: {
              DateGreaterThan: {
                'aws:CurrentTime': '2024-02-07T02:17:26.975344',
              },
              DateLessThan: {
                'aws:CurrentTime': '2024-02-10T01:16:35+0000',
              },
            },
            Effect: 'Allow',
            Action: [
              's3:Get*',
              's3:List*',
              's3:Describe*',
              's3-object-lambda:Get*',
              's3-object-lambda:List*',
            ],
          },
        ],
        expiration: '',
        id: '401986845158-test-key4',
        account_id: '401986845158',
        end_users_emails: [
          'abiju@chanzuckerberg.com',
        ],
      },
    ];
  }

  async createKey(req: CreateKeyUserInput): Promise<CreateKeyResponse> {
    if (req.iam_user_name === 'fail') {
      return {
        success: false,
        error: 'Keymon request failed',
      };
    }
    this.keys.push({
      purpose: req.purpose,
      central_creator_email: 'logged-in-user@company.com',
      iam_user_name: req.iam_user_name,
      czi_users_emails: req.czi_users_emails,
      current_status: 'ACTIVE',
      creation: new Date().toISOString(),
      iam_statements: req.iam_statements,
      expiration: req.expiration,
      id: `${req.aws_account_id}-${req.iam_user_name}`,
      account_id: req.aws_account_id,
      end_users_emails: req.end_users_emails,
    });
    return {
      success: true,
      message: 'Keymon request created',
      AccessKey: {
        UserName: req.iam_user_name,
        AccessKeyId: 'AKIAIOSFODNN7-EXAMPLE',
        Status: 'Active',
        SecretAccessKey: 'ksdhfg83465sdjfhg3487r668sudyfb-EXAMPLEKEY',
      },
    };
  }

  async deleteKey(aws_account_id: string, iam_user_name: string): Promise<DeleteKeyResponse> {
    const listResp = await this.listKeys();
    if (!listResp.approved_aws_accounts[aws_account_id]) {
      return {
        success: false,
        message: 'AWS account not found',
        error: 'AWS account not found',
      };
    }
    if (!listResp.keys.find((k) => k.iam_user_name === iam_user_name)) {
      return {
        success: false,
        message: 'IAM user not found',
        error: 'IAM user not found',
      };
    }
    this.keys = listResp.keys.filter((k) => k.iam_user_name !== iam_user_name);
    return {
      success: true,
      message: 'Keymon delete request successful',
    };
  }

  async listKeys(): Promise<ListKeyResponse> {
    return {
      keys: this.keys,
      success: true,
      approved_aws_accounts: {
        401986845158: 'czi-playground',
      },
    };
  }
}
